import React from "react";

const ThankYou = ({destinationUrl, thankYouImg}) => {
  return (
    <section className="thank-you">
        <a className="skip_desktop" href={destinationUrl}>SKIP</a>
        <div className="thankyou_container">
            <img src={require(`../../assets/images/${thankYouImg}`)} alt="" />
            <p> <span>'Thank you</span> for submitting your preferences</p>
            <a href={destinationUrl} className="mobile-skip">SKIP</a>
        </div>
    </section>  
  );
};

export default ThankYou;
